import React, { useState } from 'react';
import error from '../assets/404png';
import Loader from '../common/Loader';

const ErrorPage = () => {
  const [showLoader, setShowLoader] = useState(true);
  setTimeout(() => {
    setShowLoader(false);
  }, 500);
  return (
    <>
      {showLoader && (
        <div className='inline-block'>
          <Loader />
        </div>
      )}
      {!showLoader && (
        <div className='flex items-center  justify-center my-20'>
          <img
            src={error}
            alt=''
            className='w-[50%]'
          />
        </div>
      )}
    </>
  );
};

export default ErrorPage;
